var _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToyotaCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 19 19",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 19,
    maskUnits: "userSpaceOnUse",
    width: 19,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.5 0c-5.24671 0-9.5 4.25329-9.5 9.5 0 5.2467 4.25329 9.5 9.5 9.5 5.2467 0 9.5-4.2533 9.5-9.5 0-5.24671-4.2533-9.5-9.5-9.5zm5.2583 6.26574c-.4055-.41881-1.0738-.42959-1.4926-.02406l-5.42503 5.25222-2.06944-2.21459-.09641-.09113c-.40295-.3358-1.00234-.32682-1.39551.04059-.42594.39803-.44857 1.06603-.05054 1.49193l2.80341 3 .09765.0922c.40824.3392 1.01639.3245 1.40785-.0546l6.19662-5.99998.0894-.09801c.3286-.40884.309-1.00798-.0654-1.39457z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.5 0c-5.24671 0-9.5 4.25329-9.5 9.5 0 5.2467 4.25329 9.5 9.5 9.5 5.2467 0 9.5-4.2533 9.5-9.5 0-5.24671-4.2533-9.5-9.5-9.5zm5.2583 6.26574c-.4055-.41881-1.0738-.42959-1.4926-.02406l-5.42503 5.25222-2.06944-2.21459-.09641-.09113c-.40295-.3358-1.00234-.32682-1.39551.04059-.42594.39803-.44857 1.06603-.05054 1.49193l2.80341 3 .09765.0922c.40824.3392 1.01639.3245 1.40785-.0546l6.19662-5.99998.0894-.09801c.3286-.40884.309-1.00798-.0654-1.39457z",
    fill: "#e50c22",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaCheckmark);
export default __webpack_public_path__ + "static/media/toyota-checkmark.bb0e848f.svg";
export { ForwardRef as ReactComponent };